import {IBackendCaller} from "./backendCaller";

const processedBookingsDefaultUrl = "/api/processedBookings";

export interface ITransactionService {
  /**
   * Fetches transactions from the server.
   * @param selectedDate Contains month for which the transactions are to be fetched.
   * @param villageId Id of Village for which transactions are to be fetched.
   */
  getTransactions: (
    villageId: string,
    startDate: Date,
    endDate: Date
  ) => Promise<any>;
}

export class TransactionService implements ITransactionService {
  backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  getTransactions = async (
    villageId: string,
    startDate: Date,
    endDate: Date
  ) => {
    return await this.backendCaller.callApi(
      "GET",
      `${processedBookingsDefaultUrl}?villageId=${villageId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
    );
  };
}
